/** Money display precision across Payroll screens — an ORG-WIDE setting
 *  (`money_display` in Payroll Settings, TA-only edit), not a per-person
 *  choice. `rupees` = whole rupees (`₹1,23,457`), `paisa` = two decimals
 *  (`₹1,23,456.78`). Default is whole rupees.
 *
 *  Plain module state, set by `<MoneyPrecisionScope>` from the server value
 *  before its subtree renders, so `formatINR` can stay a plain function. */
export type MoneyPrecision = "rupees" | "paisa";

let current: MoneyPrecision = "rupees";

export function setMoneyPrecision(p: MoneyPrecision): void {
  current = p;
}

export function getMoneyPrecision(): MoneyPrecision {
  return current;
}

/** Fraction digits for the org's current setting. */
export function moneyDecimals(): number {
  return current === "paisa" ? 2 : 0;
}
